import React, { Component } from 'react';
export const Page = props => (
  <div className="project">

    {/* ==== EDIT BELOW THIS LINE ==== */}
    
    <h1> Company Flyer: Expii </h1>

    
    <div className="imgs max700">
        <div>
            <img src={require('../assets/graphicDesign/expiiFlyer.png')} data-skip-gallery/>
        </div>
    </div>

    <p>I designed and created the above flyer for Expii, an online learning company. Expii 
    produces and hosts lessons and practice problems for math and science subjects. During 
    my time as Markeing and Graphics Lead at <a href="https://www.expii.com/" target="_blank">Expii</a> in 2017, I first began by creating the 
    above flyer to put up around local areas to raise awareness of Expii and its specialties. The 
    above flyer was designed in accordance with the company's branding at the time.</p>
    

    

    {/* ==== EDIT ABOVE THIS LINE ==== */}

  </div>
)






// worked with the rabbi to developed visual 
    //symbols to represent each of the prayers in the Shabbat in order to guide the members 
    //with ASD through the ceremony. These symbols will be presented to the members via a 
    //large banner on the temple’s stage as well as on personal bookmarks that correspond 
    //with the banner. The bookmarks will also have a sticker packet with the symbols printed 
    //as stickers, to be placed on each of the corresponding sections for the current prayer 
    //on the bookmarks. The visually and physically interactive elements of these materials 
    //will help to add more sensorial aspects to the Shabbat, further benefitting Temple Sinai’s members with ASD.